import { render, staticRenderFns } from "./industryTrends.vue?vue&type=template&id=f909029c&scoped=true"
import script from "./industryTrends.vue?vue&type=script&lang=js"
export * from "./industryTrends.vue?vue&type=script&lang=js"
import style0 from "./industryTrends.vue?vue&type=style&index=0&id=f909029c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f909029c",
  null
  
)

export default component.exports